export default {"links":"EmwW4","linkItem":"OxASZ","logo":"vDQAZ","isSelected":"_7uQyg"};